import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { DevelopmentHelpers } from 'app/shared/utilities/developHelpers';
import * as bootstrap from 'bootstrap';

@Component({
  selector: 'file-list',
  templateUrl: './file-list.component.html',
  styleUrls: ['./file-list.component.css']
})
export class FileListComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() files;
  @Input() preselected: string[];
  @Output() selected  = new EventEmitter<string[]>();
  @Output() modalId = new EventEmitter<string>();

  help = new DevelopmentHelpers();
  uniqueId = this.help.guid.newGUID();

  list = [];
  tagged = [];
  modal;

  constructor() { }

  ngOnInit(): void {
    this.modalId.emit('fileList-' + this.uniqueId)
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if(!!changes.files && !!changes.files.currentValue) this.extractFiles();
    if(!!changes.preselected && !!changes.preselected.currentValue) this.tagged = this.preselected;
  }

  ngAfterViewInit(): void {
    this.modal = new bootstrap.Modal(document.getElementById('fileListModal-' + this.uniqueId));
  }

  async extractFiles(){
    let f = [];
    this.files.files.forEach(x => {
      f = f.concat(x.files)
    });
    let unique = Array.from(new Set(f.map(x => x.fileId)));
    let output = []; 
    unique.forEach(x => {
      let file = f.find(y => y.fileId == x);
      output.push(file)
    }
      )
    this.list = output;
  }

  select(id){
    if(this.tagged.includes(id)) this.tagged = this.tagged.filter(x => x != id);
    else this.tagged.push(id)
  }

  emit(){
    this.selected.emit(this.tagged);
  }
}
